// src/modules/agents/routes.jsx
import { Routes, Route } from 'react-router-dom';
import AgentList from './pages/AgentList';
import AgentForm from './pages/AgentForm';
import AgentDetails from './pages/AgentDetails';
import AgentSettlement from './pages/AgentSettlement';

function AgentRoutes() {
  return (
    <Routes>
      <Route path="/" element={<AgentList />} />
      <Route path="/settlements" element={<AgentSettlement />} />
      <Route path="/create" element={<AgentForm />} />
      <Route path="/edit/:id" element={<AgentForm />} />
      <Route path="/:id" element={<AgentDetails />} />
    </Routes>
  );
}

export default AgentRoutes;
